<mat-card-header class="flex align-items-center">
  <shared-title>{{ this.data ? 'Editar' : 'Crear' }} Empresa</shared-title>
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>

<form [formGroup]="companyForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <shared-input
      [labelTitle]="'Nombre'"
      [control]="$any(companyForm.get('name'))"
      type="text"
      onkeydown="return /[a-z,0-9 ]/i.test(event.key)" />
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [styleText]="'uppercase'"
        [labelTitle]="'Claro ID'"
        [control]="$any(companyForm.get('code'))" />
      <shared-select
        class="w-full"
        [labelTitle]="'País'"
        [control]="$any(companyForm.get('idCountry'))"
        [options]="countries()"
        [selectId]="'countryid'" />
    </div>
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Nit/RUC'"
        [control]="$any(companyForm.get('nit'))" />
      <shared-input
        class="w-full"
        [labelTitle]="'Número de contrato'"
        [control]="$any(companyForm.get('contractNumber'))" />
    </div>

    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Número de factura'"
        [control]="$any(companyForm.get('invoiceNumber'))" />
      <shared-input
        class="w-full"
        [labelTitle]="'Representante'"
        [control]="$any(companyForm.get('manager'))"
        type="text"
        onkeydown="return /[a-z, ]/i.test(event.key)" />
    </div>
    <shared-input
      class="w-full"
      [labelTitle]="'Correo electrónico del representante'"
      [type]="'email'"
      [control]="$any(companyForm.get('managerContact'))"
      [styleText]="'lowercasse'" />
    <shared-text-area
      class="w-full"
      [labelTitle]="'Dirección'"
      [control]="$any(companyForm.get('address'))" />

    <shared-select
      class="w-full"
      [labelTitle]="'Tema'"
      [control]="$any(companyForm.get('idTheme'))"
      [options]="themes()"
      [selectId]="'idTheme'" />
    @if (!data) {
      <shared-input
        class="w-full"
        [labelTitle]="'Cantidad de licencias'"
        [type]="'number'"
        pattern="[0-9]*"
        (keydown)="preventDecimal($event)"
        [control]="$any(companyForm.get('usersCount'))" />
    }
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <div class="w-full">
        <button type="button" mat-raised-button (click)="fileInput.click()">
          Seleccionar Logo*
        </button>
        <input
          hidden
          (change)="onFileSelected($event)"
          #fileInput
          type="file" />
      </div>
      <div class="w-full flex flex-column">
        @if (isImageSaved) {
          <img [src]="imgBase64()" class="w-3" />
        } @else {
          <img src="../../../../../assets/img/placeholder.svg" class="w-3" />
        }
        <span style="color: red">{{ imageError }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'">
      Cancelar
    </shared-button>

    <shared-button
      [disabled]="!companyForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'">
      Guardar
    </shared-button>
  </mat-dialog-actions>
</form>
